import React from 'react';
import SectionHead from './SectionHead';
import Portrait from './Portrait';
import { useLang } from '../LangContext';

export default function About() {
  const { t } = useLang();

  return (
    <section className="s fullpage-section" id="about">
      <div className="s__inner">
        <SectionHead label={t.about.label} />
        <div className="about about--photo">
          <Portrait t={t} />
          <p className="about__lede">
            <span className="hi">→</span>{' '}
            <span dangerouslySetInnerHTML={{ __html: t.about.lede }} />
          </p>
          <dl className="about__meta">
            <div className="about__meta-row"><dt>{t.about.metaName}</dt><dd className="v">TRAORE Lamine</dd></div>
            <div className="about__meta-row"><dt>{t.about.metaRole}</dt><dd className="v">Senior Fullstack</dd></div>
            <div className="about__meta-row"><dt>{t.about.metaBased}</dt><dd className="v">Abidjan, CI</dd></div>
            <div className="about__meta-row"><dt>{t.about.metaSetup}</dt><dd className="v">100% remote</dd></div>
            <div className="about__meta-row"><dt>{t.about.metaAvail}</dt><dd className="v">Freelance / CDI</dd></div>
          </dl>
        </div>
      </div>
    </section>
  );
}
